import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivational-coaching-courses',
  templateUrl: './motivational-coaching-courses.component.html',
  styleUrls: ['./motivational-coaching-courses.component.scss']
})
export class MotivationalCoachingCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
